import { computed } from 'vue';

import { useViewBreakpoints } from '@/composables/useViewBreakpoints';

export const HEADER_HEIGHT_DESKTOP = 88;
export const HEADER_HEIGHT_MOBILE = 72;
export const HEADER_GAP_DESKTOP = 16;
export const HEADER_GAP_MOBILE = 8;

const { isLegacyMobile } = useViewBreakpoints();

const headerHeight = computed((): number => {
  return isLegacyMobile.value
    ? HEADER_GAP_MOBILE + HEADER_HEIGHT_MOBILE
    : HEADER_GAP_DESKTOP + HEADER_HEIGHT_DESKTOP;
});

export const useHeader = () => {
  return {
    headerHeight
  };
};
